<script>
import { infoMethods, infoDetailsMethods } from '@state/helpers'

export default {
  props: {
    deviceAggregateHour: {
      type: Array,
      default: () => [],
    },
    startHour: {
      type: Number,
      default: () => 0,
    },
    endHour: {
      type: Number,
      default: () => 0,
    },
  },

  computed: {
    cachedDeviceActivitiesSorted: function() {
      let cachedDeviceStateAggregateHourSorted = this.deviceAggregateHour
      let deviceActivities = []

      cachedDeviceStateAggregateHourSorted = cachedDeviceStateAggregateHourSorted.filter(
        (obj) => {
          return obj.hour >= this.startHour && obj.hour <= this.endHour
        }
      )

      cachedDeviceStateAggregateHourSorted.forEach(function(item, index) {
        deviceActivities.push(item.deviceActivities)
      })

      return deviceActivities
        .flat()
        .filter(
          (deviceActivity, index, self) =>
            index === self.findIndex((t) => t.id === deviceActivity.id)
        )
    },
  },

  methods: {
    ...infoMethods,
    ...infoDetailsMethods,
  },
}
</script>

<template>
  <div v-if="cachedDeviceActivitiesSorted">
    <div class="pt-2 pb-1 pl-1 small text-muted">
      <span> Activities {{ startHour }}:00 - {{ endHour + 1 }}:00 </span>
    </div>
    <b-badge
      v-for="activity in cachedDeviceActivitiesSorted"
      :key="activity.id"
      class="mr-2 cycle-badge"
    >
      {{ activity.name }}
    </b-badge>
  </div>
</template>

<style lang="css" scoped>
.cycle-badge{
  cursor: pointer;
}

.cycle-badge:hover {
  transform: scale(1.15);
}
</style>
